import { defineComponent as _defineComponent } from 'vue'
import { inject, computed } from 'vue';
import {
  Row,
  Heading,
  ButtonContainer,
  ButtonPrimary,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IPortfolioSummary } from '@/modules/wealth/services/investment/investment-types';
import { IDetailModalProps } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'RedeemDetail',
  props: {
    modalInfo: null
  },
  setup(__props: any) {

const props = __props as {
  modalInfo: IDetailModalProps;
}

const nebraska = NebraskaColors;

const closeModal = inject('closeDetailModal') as () => void;



const sortedPortfolioSummary = computed(() => {
  const portfolioSummary = Array.isArray(
    props.modalInfo?.details?.allocations?.portfolioSummary
  )
    ? props.modalInfo.details.allocations.portfolioSummary
    : [];

  return [...portfolioSummary].sort(
    (a: IPortfolioSummary, b: IPortfolioSummary) =>
      a.expirationTime.value - b.expirationTime.value
  );
});

return { __sfc: true,nebraska, closeModal, props, sortedPortfolioSummary, Row, Heading, ButtonContainer, ButtonPrimary, BaseText }
}

})